import { apiBaseUrl } from "./config";

const baseUrl = `${apiBaseUrl}/documents`;

export async function getDocumentGroups() {
  const r = await fetch(`${baseUrl}/groups`);
  if (!r.ok) throw { status: r.status };
  return r.json();
}

export async function getAdminDocumentGroups(token) {
  const r = await fetch(`${baseUrl}/admin/groups`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!r.ok) throw { status: r.status };
  return r.json();
}

export async function createDocumentGroup(token, label, sortOrder = 0) {
  const r = await fetch(`${baseUrl}/admin/groups`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ label, sortOrder })
  });
  const data = await r.json();
  if (!r.ok) throw data;
  return data;
}

export async function updateDocumentGroup(token, groupId, updates) {
  const r = await fetch(`${baseUrl}/admin/groups/${groupId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(updates)
  });
  const data = await r.json();
  if (!r.ok) throw data;
  return data;
}

export async function uploadDocument(token, groupId, title, description, file) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('groupId', groupId);
  formData.append('title', title);
  if (description) formData.append('description', description);

  const r = await fetch(`${baseUrl}/admin/documents`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData
  });
  const data = await r.json();
  if (!r.ok) throw data;
  return data;
}

export async function replaceDocumentFile(token, documentId, file) {
  const formData = new FormData();
  formData.append('file', file);

  const r = await fetch(`${baseUrl}/admin/documents/${documentId}/file`, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${token}` },
    body: formData
  });
  const data = await r.json();
  if (!r.ok) throw data;
  return data;
}

export async function updateDocumentMeta(token, documentId, updates) {
  const r = await fetch(`${baseUrl}/admin/documents/${documentId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(updates)
  });
  const data = await r.json();
  if (!r.ok) throw data;
  return data;
}
